import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ThemeProvider } from 'next-themes'
import { router } from '@/router'
import { queryClient } from '@/lib/query-client'
import { Toaster } from '@/components/ui/sonner'
import { AutoHideScrollbars } from '@/components/business/auto-hide-scrollbars'
import { PageHeaderProvider } from '@/components/business/page-header-context'
import { AuthRecoveryBootstrap } from '@/features/auth/AuthRecoveryBootstrap'
import { AiConversationAuthBoundary } from '@/features/ai-doc/components/AiConversationAuthBoundary'
import { ConsultWsBootstrap } from '@/features/consult/components/consult-ws-bootstrap'
import { SiteTitleBootstrap, SiteFaviconBootstrap } from '@/features/site/api'
import { APP_TITLE } from '@/config/app'
import 'streamdown/styles.css'
import '@/styles/globals.css'

const reactQueryDevtoolsFlag = import.meta.env.VITE_SHOW_REACT_QUERY_DEVTOOLS
const showReactQueryDevtools =
  reactQueryDevtoolsFlag === 'true' || (import.meta.env.DEV && reactQueryDevtoolsFlag !== 'false')

document.title = APP_TITLE

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      storageKey="legal-web:theme"
    >
      <QueryClientProvider client={queryClient}>
        <SiteTitleBootstrap />
        <SiteFaviconBootstrap />
        <AuthRecoveryBootstrap />
        <AiConversationAuthBoundary />
        <ConsultWsBootstrap />
        <AutoHideScrollbars />
        <PageHeaderProvider>
          <RouterProvider router={router} />
        </PageHeaderProvider>
        <Toaster position="top-center" richColors closeButton />
        {showReactQueryDevtools && (
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
        )}
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
